<template>
  <section class="main_wrap">
    <!--工具条-->
    <el-col :span="24" class="toolbar search-bar" style="padding-bottom: 0px;">
          <el-input v-model="key_word" placeholder="请输入姓名或手机号" @keyup.enter.native="getUsers"></el-input>
          <el-button type="primary" @click="getUsers">查询</el-button>
    </el-col>

    <!--列表-->
    <el-table :data="users" highlight-current-row v-loading="listLoading" style="width: 100%;">
      <el-table-column
        label="ID"
        width="">
        <template slot-scope="scope">
          <span>{{ scope.row.uuid }}</span>
        </template>
      </el-table-column>

      <el-table-column label="姓名" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>

      <el-table-column label="电话" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.mobile_number }}</span>
        </template>
      </el-table-column>

      <el-table-column label="身份证" min-width="">
        <template slot-scope="scope">
          <span>{{ scope.row.idcard_number }}</span>
        </template>
      </el-table-column>

      <el-table-column label="类型" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.type }}</span>
        </template>
      </el-table-column>

      <el-table-column label="银行名称" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.card_name }}</span>
        </template>
      </el-table-column>

      <el-table-column label="银行卡号" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.card_number }}</span>
        </template>
      </el-table-column>

     <el-table-column label="持卡人" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.card_owner }}</span>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <span class="total_number" style="margin-top: 7px;display: inline-block;"> 共计 <span v-model="total_count"> {{total_count}} </span> 条 </span>
      <el-pagination
        v-show="pagination"
        style="float:right;"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="15"
        layout="prev, pager, next, jumper"
        :total="total_count">
      </el-pagination>
    </el-col>
  </section>
</template>

<script>
  import { getContractUsersList } from '../../api/api';
  //import http from '../../utils/http'
  //import api from '../../utils/apis'
  export default {
    created() {
      this.listLoading = true;
      //get list
      getContractUsersList()
        .then((res) => {
          if(res.status === 0){
            this.users = res.data.data;
            this.total_count = res.data.total_count;
            this.listLoading = false;
            if(res.data.total_pages < 2){
              this.pagination = false;
            }
          }
        })
    },
    beforeRouteUpdate(to, from, next) {
      this.listLoading = true;
      //get list
      getContractUsersList(to.query)
        .then((res) => {
          if(res.status === 0){
            this.users = res.data.data;
            this.total_count = res.data.total_count;
            this.listLoading = false;
            if(res.data.total_pages < 2){
              this.pagination = false;
            }
          }
        })
    },
    data() {
      return {
        key_word: '',
        currentPage: 1,
        users: [],
        listLoading: false,
        total_count: 0,
        pagination: true
      }
    },
    methods: {
//      fetchData: async function () {
//        let params = {
//        }
//        const res = await http.get(api.getContractUsersList, params);
//        console.log(res,'res');
//      },
      getUsers() {
        let params = {
          'key_word': this.key_word,
          'page': this.currentPage
        };
        getContractUsersList(params).then((res) => {
          if(res.status === 0){
            this.users = res.data.data;
            this.total_count = res.data.total_count;
            if(res.data.total_pages < 2){
              this.pagination = false;
            }else {
              this.pagination = true;
            }
          }
        })
      },
      handleCurrentChange(val) {
        // console.log(val);
        this.currentPage = val;
        this.getUsers();
      },
    },
//    mounted: function () {
//      this.fetchData()
//    },
  }

</script>

<style lang="scss">
  @import "../../assets/css/common.scss";
</style>



// WEBPACK FOOTER //
// src/views/tableList/ContractUsers.vue